import styled from '@emotion/styled';

const grayLineColor = `#dedfe0`;
const disabledIconColor = `#c9cbcd`;
const enabledIconColor = `#292F36`;
const fontFamily = "'Maax', sans-serif";

export const Root = styled.div`
  .DraftEditor-root {
    position: relative;
  }

  & > div {
    border-width: 0;
    font-family: ${fontFamily};
    background: #ffffff;
    > div:first-of-type {
      display: flex;
      align-items: center;
      height: 58px;
      margin-right: 0;
      margin-left: 0;
      padding: 0 14px;
      border-bottom: 2px solid #dedfe0;
      > div {
        margin-bottom: 0;
      }
      input {
        color: #292f36;
        font-size: 14px;
        font-family: ${fontFamily};
      }
    }
    > div:last-child {
      & > div > div > div {
        padding: 16px;
        font-weight: normal;
        line-height: 2.25rem;
        a:hover {
          text-decoration: none;
        }
      }
    }
    li,
    span {
      color: #292f36;
      font-size: 16px;
    }
    a li,
    a span {
      color: #5000b9 !important;
    }
    button {
      border-color: ${grayLineColor};
      background-image: none;

      span {
        color: ${enabledIconColor};
      }
      &:disabled {
        span {
          color: ${disabledIconColor};
        }
      }
    }
  }
`;
